import HomeComponent from "../Components/HomeComponent";

const HomePage = () => {
  return (
    <div>
      <HomeComponent />
    </div>
  );
}

export default HomePage;